import { ResponsiveContainer } from "recharts"

function GraficoComponent({ children, title }: any) {
  return (
    <div className="dashboardDefaultDiv">
      <h1 className='dashboardDefaultP'>{title}</h1>
      <ResponsiveContainer height={350} width={"100%"}>
        {children}
      </ResponsiveContainer>
    </div>)
}

export default GraficoComponent